function storageSet(key, value) {
	try {
		localStorage.setItem(key, value);
	} catch (e) {
		// console.log('Erro ao salvar no storage: ' + e);
		return false;
	}
	return true;
}

function storageGet(key) {
	try {
		const value = localStorage.getItem(key);
		if (value !== null) {
			return value;
		}
	} catch (e) {
		// console.log('Erro ao ler no storage: ' + e);
		return null;
	}
	return null;
}

function storageDelete(key) {
	try {
		localStorage.removeItem(key);
	} catch (e) {
		// console.log('Erro ao deletar no storage: ' + e);
		return false;
	}
	return true;
}

export { storageSet, storageGet, storageDelete };
